import { useCallback } from 'react';
import { UXF } from 'UXF';

import { EVoxRoles } from 'providers/declare';

export function useSendUXFEndedEvent() {
    return useCallback(() => {
        const storedProperties = UXF.getStoredProperties();

        if (storedProperties) {
            const role = storedProperties.meeting_user_role;

            const eventName = role === EVoxRoles.MANAGER ? 'CALL_ENDED_MANAGER' : 'CALL_ENDED_CLIENT';

            UXF.sendEvent(eventName, storedProperties);
        }
    }, []);
}
